import request from '../../../axios';

export const deleteChat = async (guid?: string) => {
  const {data}: {data: IResponse} = await request.delete(
    `/api/v2/shop/chat/${guid}`,
  );
  return data;
};
